<template>

  <div v-if="placement && (editMode || filled)">
    <div class="card-header">
      <i
        v-if="!editable && editMode"
        class="fas fa-pencil-alt"
        :title="$t('Edit')"
        @click.stop="editSection(true)"
        style="cursor: pointer; float: right;">
        </i>
      <strong>{{ $t('Recommendation') }}</strong>
    </div>
    <div
      v-if="editable"
      class="card-body">
      <form v-on:submit.prevent="save(placementEdit)">
        <div class="form-group">
          <input
            v-autofocus
            type="text"
            class="form-control"
            v-model="placementEdit.referral_email"
            :placeholder="$t('Email')">
          <ValidateMessage :error="validateErrors.referral_email" />
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            v-model="placementEdit.referral_name"
            :placeholder="$t('Name')">
          <ValidateMessage :error="validateErrors.referral_name" />
        </div>
        <div :class="{'box-loading': loading}">
          <button
            type="submit"
            class="btn btn-primary">
            {{ $t('Save') }}
            </button>
          <button
            type="button"
            class="btn btn-light"
            @click.stop="editSection(false)">
            {{ $t('Cancel') }}
            </button>
        </div>
      </form>
    </div>
    <div
      v-if="!editable && filled"
      class="card-body">
      {{ placement.referral_email }} <span v-if="placement.referral_name">({{ placement.referral_name }})</span>
    </div>
  </div>

</template>

<script>
import _ from 'lodash'
export default {
  name: 'CandidateProfileRefer',
  components: {
  },
  props: [
    'editMode'
  ],
  data () {
    return {
      loading: false,
      sectionEdit: false,
      placementEdit: {},
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
    editable () {
      return this.sectionEdit && this.editMode
    },
    candidateJobId () {
      return this.$route.query.candidate_job_id
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    placement () {
      if (!this.candidateJobId) return null
      return this.candidate.placements.find((placement) => {
        return placement.job_id === this.candidateJobId
      })
    },
    filled () {
      return this.placement && this.placement.referral_email
    }
  },
  methods: {
    editSection (status) {
      this.sectionEdit = status
      this.placementEdit = _.pick(this.placement, [
        '_id',
        'referral_email',
        'referral_name'
      ])
    },
    save (data) {
      this.loading = true

      this.$store.dispatch('updatePlacement', {
        _id: data._id,
        referral_name: data.referral_name,
        referral_email: data.referral_email
      })
      .then((response) => {
        this.loading = false
        this.sectionEdit = false
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileRefer.vue